import { Checkmark } from "../../../assets/icons/Checkmark";
import { useCustomisationFeaturesState } from "./use-customisation-features-state";
import type {
  Product,
  ProductBase,
  RelatedProduct,
} from "@made-people/grease-product";
import type { CustomisationFeature } from "../settings";

export const CustomisationFeatures = (props: {
  view: boolean;
  productBase: ProductBase;
  relatedProducts: RelatedProduct[];
  features: CustomisationFeature[];
  onTargetProductChange: (product: Product) => void;
  onUrlChange: (url: string) => void;
  onNoticeChange: (active: boolean) => void;
}) => {
  const { items, toggleProduct } = useCustomisationFeaturesState(props);

  return (
    <div className="flex flex-col gap-8">
      {items.map((item, index) => {
        const {
          feature,
          isSelected,
          canToggle,
          imageUrl,
          inactiveImageUrl,
          imageAlt,
        } = item;
        return (
          <div className="flex flex-col gap-3" key={index}>
            <h2 className="text-body-md font-semibold">{feature.heading}</h2>
            <div
              className={`flex flex-col gap-4 overflow-hidden transition-[max-height] duration-200 ${
                props.view ? "max-h-[600px]" : "max-h-0"
              }`}
            >
              <div className="flex flex-row gap-4">
                {imageUrl && (
                  <img
                    className="w-1/2 aspect-square object-cover rounded-md"
                    src={
                      !isSelected && inactiveImageUrl
                        ? inactiveImageUrl
                        : imageUrl
                    }
                    alt={imageAlt}
                  />
                )}
                <p className="text-body-sm w-1/2">{feature.body}</p>
              </div>
            </div>
            <div
              className={`flex flex-row justify-center rounded-md p-2 ${
                canToggle ? "bg-[#F0ECE4]" : "bg-[#D9D9D9] text-[#38383866]"
              }`}
            >
              <button
                className={`text-body-sm flex w-1/2 items-center justify-center gap-2 ${
                  isSelected ? "" : "text-white bg-black rounded-md py-2"
                }`}
                disabled={!canToggle}
                onClick={() => toggleProduct(feature.featureName)}
              >
                {feature.firstToggleLabel}
                {!isSelected && <Checkmark className="h-4 w-4" />}
              </button>
              <button
                className={`text-body-sm flex w-1/2 items-center justify-center gap-2 ${
                  isSelected ? "text-white bg-black rounded-md py-2" : ""
                }`}
                disabled={!canToggle}
                onClick={() => toggleProduct(feature.featureName)}
              >
                {feature.secondToggleLabel}
                {isSelected && <Checkmark className="h-4 w-4" />}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
